import React from 'react'

const credit = (props) => {
    return (
        <div className="credit">
            <span className="creditImage">
                <img src={props.image} alt=""/>
            </span>
            <span className="creditName">{ props.name }</span>
        </div>
    );
}

export default credit;